'use strict';

// The wheel used in the game show 'Wheel of Fortune'.
export const PRESET1 = {
  name: 'I Like to Scoop',
  winningText: 'You get: <b>%s</b>',
  background: '',
  removeWinning: false,
  prizes: [
    { name: '5% off', freq: 8, bg: '#ce93d8', text: '#222', hide: false, make: true, fontMod: 1.4 },
    { name: 'Free topping', freq: 8, bg: '#ffcc44', text: '#222', hide: false, make: true, fontMod: 1.5 },
    { name: 'Free whipped cream', freq: 8, bg: '#e787a7', text: '#222', hide: false, make: true, fontMod: 1 },
    { name: '10% off', freq: 8, bg: '#00aef0', text: '#222', hide: false, make: true, fontMod: 1.4 },
    { name: 'Free cookie', freq: 8, bg: '#f26522', text: '#222', hide: false, make: true, fontMod: 1.5 },
    { name: 'Mini Vermonster', freq: 1, bg: '#00bb88', text: '#222', hide: false, make: true, fontMod: 1.5 },
    { name: '20% off', freq: 8, bg: '#ce93d8', text: '#222', hide: false, make: true, fontMod: 1.4 },
    { name: 'Upgrade small to large', freq: 8, bg: '#ffcc44', text: '#222', hide: false, make: true, fontMod: 1.2 },
    { name: 'Get your free song', video: 'https://youtu.be/Z1f9b7sX_XY', freq: 8, bg: '#e787a7', text: '#222', hide: false, make: false, fontMod: 1.2 },
    { name: '50% off', freq: 4, bg: '#00aef0', text: '#222', hide: false, make: true, fontMod: 1.4 },
    { name: 'Ice cream sandwich recipe', video: 'https://youtu.be/TLML0aYHf6s', freq: 8, bg: '#f26522', text: '#222', hide: false, make: false, fontMod: 1.2 },
    { name: 'Become Flavor Fanatic', video: 'https://www.benjerry.com/scoop-shops/flavor-fanatics', freq: 8, bg: '#00bb88', text: '#222', hide: false, make: false, fontMod: 1.2 }
  ]
};

// Wheel of Misfortune: SMRT disruption edition.
export const PRESET2 = {
  name: 'Wheel of Misfortune',
  winningText: 'Congratulations! You win: <b>%s</b>!',
  background: 'static/smrt.jpg',
  removeWinning: false,
  prizes: [
    { name: 'No Service', freq: 4, bg: '#FFCC80', text: '#222', hide: false, fontMod: 1 },
    { name: 'Tunnel Ponding', freq: 4, bg: '#F48FB1', text: '#222', hide: false, fontMod: 1 },
    { name: 'Delay 60 mins', freq: 4, bg: '#81D4FA', text: '#222', hide: false, fontMod: 1 },
    { name: 'Lightning Fault', freq: 4, bg: '#B39DDB', text: '#222', hide: false, fontMod: 1 },
    { name: 'Delay 10 mins', freq: 4, bg: '#C5E1A5', text: '#222', hide: false, fontMod: 1 },
    { name: 'Track Fault', freq: 4, bg: '#F48FB1', text: '#222', hide: false, fontMod: 1 },
    { name: 'Delay 40 mins', freq: 4, bg: '#81D4FA', text: '#222', hide: false, fontMod: 1 },
    { name: 'Full-day Closure', freq: 4, bg: '#FFCC80', text: '#222', hide: false, fontMod: 1 },
    { name: 'Train Fault', freq: 4, bg: 'white', text: '#222', hide: false, fontMod: 1 },
    { name: 'Delay 20 mins', freq: 4, bg: '#81D4FA', text: '#222', hide: false, fontMod: 1 },
    { name: 'Signal Fault', freq: 4, bg: '#B39DDB', text: '#222', hide: false, fontMod: 1 },
    { name: 'Delay 10 mins', freq: 4, bg: '#C5E1A5', text: '#222', hide: false, fontMod: 1 },
    { name: 'No Delay', freq: 1, bg: '#111', text: 'white', hide: false, fontMod: 1.4 },
    { name: 'Collision', freq: 2, bg: '#ef9a9a', text: '#222', hide: false, fontMod: 1 },
    { name: 'No Delay', freq: 1, bg: '#111', text: 'white', hide: false, fontMod: 1.4 }
  ]
};

// Wheel of Inquiry: select a person to answer your question.
export const PRESET3 = {
  name: 'Wheel of Inquiry',
  winningText: 'Your turn to answer the question, <b>%s</b>!',
  background: '',
  removeWinning: true,
  prizes: [
    // use defaults - freq: 4, bg: auto, text: #222, hide: false, fontMod: 1
    { name: 'James' },
    { name: 'John' },
    { name: 'Robert' },
    { name: 'Michael' },
    { name: 'William' },
    { name: 'David' },
    { name: 'Richard' },
    { name: 'Charles' },
    { name: 'Mary' },
    { name: 'Patricia' },
    { name: 'Linda' },
    { name: 'Barbara' },
    { name: 'Elizabeth' },
    { name: 'Jennifer' },
    { name: 'Maria' },
    { name: 'Susan' }
  ]
};

export const DEFAULT_PRESETS = [PRESET1, PRESET2, PRESET3];
